import React from 'react';
import { Navbar, NavSidebar } from '../components/Navigation';
import { Route, Redirect } from 'react-router-dom';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';

import Auth from '../services/AuthService';
import AuthService from '../services/AuthService';


let CoreLayout = ({ component: Component, ...rest, children, location, params, routes, message, dispatch, currentLanguage }) => {
  AuthService.setAuthUserProfile(dispatch)
  return (
    <Route  {...rest} render={matchProps => {
      if (!Auth.isLogged()) {
        return (<Redirect to={{ pathname: `/${currentLanguage}/auth/login`, state: { from: location }}} />)
      }
      return (
    <div>

      <Navbar location={location} />
      <div className="container">
        <div className="row">
          <NavSidebar {...matchProps} />
            <div className="col-lg-9">
            <Component rest={rest} matchProps={matchProps} />
            </div>
        </div>
      </div>
    </div>
  )}
} />
)};

  const mapStateToProps = (state) => {
    return {
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      message: state.Flash.message,
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      dispatch
    }
  }

  CoreLayout = connect(
    mapStateToProps,
    mapDispatchToProps
  )(CoreLayout);
export default CoreLayout;



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout.js